import React from "react"
import "./style.scss"

export default function Header({ logo }) {
  const docUploadURL = window.location.href

  return (
    <React.Fragment>
      <header>
        <nav className="navbar">
          <div className="navbar-logo" data-testid="logo">
            <a href={docUploadURL} rel="noreferrer">
              <img
                className="name"
                width="200"
                height="26"
                src={logo.icon}
                alt="Home Name"
              />
            </a>
          </div>
        </nav>
      </header>
      {/* Removed all the links aprt from header logo as per new requirements. */}
      <div className="header-padding" />
    </React.Fragment>
  )
}
